import type { Transition, Variants } from 'framer-motion'

export type CarouselSwipeEffect =
  | 'fluid-parallax'
  | 'glass-morph-fold'
  | 'kinetic-snap'
  | 'monochrome-fade'

type VariantDirection = { direction: number }

const premiumEase = [0.4, 0, 0.2, 1] as const

export const fluidParallaxVariants: Variants = {
  enter: ({ direction }: VariantDirection) => ({ x: `${direction * 18}%`, scale: 1.06, opacity: 0 }),
  center: { x: '0%', scale: 1, opacity: 1 },
  exit: ({ direction }: VariantDirection) => ({ x: `${direction * -12}%`, scale: 0.98, opacity: 0 }),
}

export const glassMorphFoldVariants: Variants = {
  enter: ({ direction }: VariantDirection) => ({
    rotateY: direction * -28,
    x: `${direction * 10}%`,
    scale: 0.94,
    opacity: 0,
    filter: 'blur(16px)',
  }),
  center: { rotateY: 0, x: '0%', scale: 1, opacity: 1, filter: 'blur(0px)' },
  exit: ({ direction }: VariantDirection) => ({
    rotateY: direction * 24,
    x: `${direction * -8}%`,
    scale: 0.96,
    opacity: 0,
    filter: 'blur(12px)',
  }),
}

export const kineticSnapVariants: Variants = {
  enter: ({ direction }: VariantDirection) => ({ x: `${direction * 100}%`, scale: 0.985, opacity: 0.82 }),
  center: { x: '0%', scale: 1, opacity: 1 },
  exit: ({ direction }: VariantDirection) => ({ x: `${direction * -100}%`, scale: 0.985, opacity: 0.7 }),
}

export const monochromeFadeVariants: Variants = {
  enter: { opacity: 0, scale: 1.025, filter: 'grayscale(1) blur(8px)' },
  center: { opacity: 1, scale: 1, filter: 'grayscale(0) blur(0px)' },
  exit: { opacity: 0, scale: 0.99, filter: 'grayscale(1) blur(6px)' },
}

export const carouselVariants: Record<CarouselSwipeEffect, Variants> = {
  'fluid-parallax': fluidParallaxVariants,
  'glass-morph-fold': glassMorphFoldVariants,
  'kinetic-snap': kineticSnapVariants,
  'monochrome-fade': monochromeFadeVariants,
}

export const carouselTransitions: Record<CarouselSwipeEffect, Transition> = {
  'fluid-parallax': { duration: 0.62, ease: premiumEase },
  'glass-morph-fold': { duration: 0.7, ease: premiumEase },
  'kinetic-snap': { type: 'spring', stiffness: 330, damping: 34, mass: 0.9 },
  'monochrome-fade': { duration: 0.58, ease: premiumEase },
}
